import { setRemoteDefinitions } from '@nx/angular/mf';
import { ExternalConfigService } from './services/external-config.service';

ExternalConfigService.loadAppConfig();

setRemoteDefinitions(ExternalConfigService.Config.remotes);

import('./bootstrap').catch((err) => console.error(err));
